const PARAGRAPH_ALL_SERIES_CAROUSEL = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on SeriesCarousel {
      id
      header
      icon
      type
      uuid
      numberOfRecords
      listing {
        nid
        author
        bodyListing
        categories {
					alias
					color
					name
					weight
				}
        category {
          colorAndURL
          label
          tid
        }
        featuredImage {
          horizontalCardImage
          verticalCardImage
        }
        memberOnly
        pathAlias
        publishedOn
        summaryListing
        title
        ... on Series {
          numberOfEpisodes
        }
      }
    }
  }
`;

export default PARAGRAPH_ALL_SERIES_CAROUSEL;
